import { DomHelper } from "../general/utils";

class Navigation {

  static initMenuButton () {
    let menu = document.getElementById('menu-button');

    if(DomHelper.elementExists(menu)) {

      menu.addEventListener('click', function () {

        if(this.classList.contains('active')) {
          this.classList.remove('active');
          DomHelper.enablePageScroll('has-overlay');
        } else {
          this.classList.add('active');
          Navigation.handleSubOnMobile();
          DomHelper.stopPageScroll('has-overlay');
        }
      });
    }
  }

  static initSubMenu () {
    let entries = document.querySelectorAll('.main-navigation ul li.sub');

    if(entries.length) {
      for (let entry of Array.from(entries)) {
        Navigation.handleSubMenuClick(entry, entries);
      }
    }
  }

  static handleSubMenuClick (el, entries) {
    el.addEventListener('click', function (e) {

      if(e.target.tagName.toLowerCase() !== 'a') {
        // prevent navigation toggle on link click
        if(el.classList.contains('opened')) {
          el.classList.remove('opened');

          window.removeEventListener('click', function(e){});
        } else {
          el.classList.add('opened');

          window.addEventListener('click', function(e){
            if (!el.contains(e.target)){
              el.classList.remove('opened');
            }
          });
        }
      }
    });
  }

  static handleSubOnMobile () {
    let entries = document.querySelectorAll('.main-navigation ul li.sub');

    for(let entry of Array.from(entries)) {

      if(entry.classList.contains('active')) {
        entry.classList.add('opened');
      }
    }
  }
}

export {
  Navigation
};